import React, { useEffect } from 'react';
import Chat from './components/Chat';
import './App.css';
import { fernetDecrypt } from './utils/fernet';
import { decodeJwt } from './utils/jwt';

function App() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const s = params.get('s');
    if (!s) return;

    async function resolveAppLink() {
      try {
        const url = `https://dev.acportal.rcp.care/app_link?id=${encodeURIComponent(s)}`;
        const res = await fetch(url, { credentials: 'omit' });
        if (!res.ok) throw new Error(`App link request failed: ${res.status}`);
        const data = await res.json();
        if (!data || data.status !== 'success' || !data.userdata) {
          throw new Error('Invalid app_link response');
        }

        const fernetKey = 'SHVGS2hmOXZocUZmeHFvcVlIa2hpYWhFeGZ4eEV3dnU=';
        const decrypted = await fernetDecrypt(data.userdata, fernetKey);
        const parts = decrypted.split('|');
        const username = parts[0] || null;
        const kcToken = parts[1] || null;
        const refreshToken = parts[2] || null;
        const env = parts[3] || null;
        const deeplink = parts[4] || null;
        const deeplinkData = parts[5] || null;

        let jwtDecoded = null;
        try {
          if (kcToken) jwtDecoded = decodeJwt(kcToken);
        } catch (e) {
          console.warn('Failed to decode JWT from kc_token', e);
        }

        // Persist for use elsewhere in the app
        if (username) localStorage.setItem('username', username);
        if (kcToken) localStorage.setItem('kc_token', kcToken);
        if (refreshToken) localStorage.setItem('refresh_token', refreshToken);
        if (env) localStorage.setItem('env', env);
        if (deeplink) localStorage.setItem('deeplink', deeplink);
        if (deeplinkData) localStorage.setItem('deeplink_data', deeplinkData);
        if (jwtDecoded?.payload) localStorage.setItem('kc_token_payload', JSON.stringify(jwtDecoded.payload));
        if (jwtDecoded?.payload["rcp-core-uid"]) localStorage.setItem('rcp_core_uid', jwtDecoded.payload["rcp-core-uid"]);
        if (jwtDecoded?.payload["name"]) localStorage.setItem('name', jwtDecoded.payload["name"]);

        console.log('[AppLink] resolved', { username, env, deeplink, deeplinkData, jwtHeader: jwtDecoded?.header, jwtPayload: jwtDecoded?.payload });
        console.log('rcp-core-uid:', jwtDecoded?.payload["rcp-core-uid"]);

        // Clean the URL by removing the sensitive 's' param
        try {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.delete('s');
          window.history.replaceState({}, '', newUrl);
        } catch (_) { /* ignore */ }
      } catch (err) {
        console.error('Error resolving app link:', err);
      }
    }

    resolveAppLink();
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <h1>Medical Chatbot</h1>
        <p>Your Remote Patient Monitoring Assistant</p>
      </header>
      <main className="App-main">
        <Chat />
      </main>
    </div>
  );
}

export default App;
